import { Store } from 'effector'
import { Thread } from '@loctypes'
import { getConfig } from '@services/context'
import ThreadModel from '@store/threads/model'

export const mapThreads = (store: Store<Thread[]>): Store<ThreadModel[]> => {
  return store.map((state) => state.filter((thread) => thread.name).map((thread) => new ThreadModel(thread)))
}

export const mapDefaultThread = (rawThreads: Store<Thread[]>, threads: Store<ThreadModel[]>) => {
  return threads.map((state) => {
    const manualThreadId = getConfig('threadId')

    // есть thread установили в конфиге виджета
    if (manualThreadId) {
      const manualThread = state.find((thread) => thread.id === manualThreadId)
      // если thread не был найдет, выполняем далее стандартный flow
      if (manualThread) {
        return manualThread
      }
    }

    // находим, который без имени как основной
    const systemDefaultThread = rawThreads.getState().find((thread) => thread.type === 'onLinked' && thread.isDefault)

    // legacy кейс
    if (!systemDefaultThread) {
      return undefined
    }

    // теперь с именем
    const defaultThread = state.find((thread) => {
      return thread.transferId === systemDefaultThread.transferId && thread.name
    })

    return defaultThread
  })
}
